import { CssBaselineProps, CssBaseline as MuiCssBaseline } from "@mui/material";

type Props = CssBaselineProps;

export const CssBaseline = ({ children, ...props }: Props) => {
  return <MuiCssBaseline {...props}>{children}</MuiCssBaseline>;
};
